const videoContainers = document.querySelectorAll('.video-container');

if (videoContainers.length) {

    let tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let players = [],
        currentPlayer = null;

    function onYouTubeIframeAPIReady() {
        videoContainers.forEach((container, index) => {
            let videoId = container.getAttribute('data-video-id');
            let posterImage = container.querySelector('.poster-image');
            let playerElement = container.querySelector('.player');
            let player;

            console.log('Setting up video container with ID:', videoId);

            posterImage.addEventListener('click', function () {
                if (!player) {
                    player = new YT.Player(playerElement, {
                        height: '360',
                        width: '640',
                        videoId: videoId,
                        playerVars: {
                            'autoplay': 1,
                            'controls': 1
                        },
                        events: {
                            'onReady': function (event) {
                                playerElement = event.target.getIframe();
                                playerElement.style.display = 'block';
                                console.log('Player element displayed for video ID:', videoId);
                            },
                            'onStateChange': onPlayerStateChange
                        }
                    });
                    players.push(player);
                } else {
                    playerElement.style.display = 'block'; // Ensure the player element is visible
                    player.playVideo();
                }

                if (currentPlayer && currentPlayer !== player) {
                    currentPlayer.pauseVideo();
                }
                currentPlayer = player;

                posterImage.style.display = 'none';
            });

            function onPlayerStateChange(event) {
                if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED) {
                    playerElement.style.display = 'none';
                    posterImage.style.display = 'block';
                    console.log('Poster displayed for video ID:', videoId);
                }
            }
        });
    }
    
}